export default __webpack_public_path__ + "static/media/display-4.282d0f35.jpg";